export const ModuleContext = 'context';
export const ModuleEmployee = 'employee';
export const ModuleDbOption = 'dbOptions';
export const ModuleAccountTransfer = 'diAccountTransfer';

export const ModuleAccount = 'diAccount';
export const ModuleSystemAccount = 'systemAccount';
export const ModuleRole = 'role';
export const ModuleBADeposit = 'baDeposit';
export const ModuleBAWithdraw = 'baWithdraw';
export const ModuleBAInternalTransfer = 'baInternalTransfer';
export const ModuleBAAdvanceNSNN = 'baAdvanceNSNN';
export const ModuleBudgetChapter = 'diBudgetChapter';
export const ModuleBudgetChapterGrade = 'diBudgetChapterGrade';
export const ModuleDiCacheConfig = 'diCacheConfig';

export const ModuleStock = 'diStock';
export const ModuleBankInfo = 'diBankInfo';
export const ModuleBankStandard = 'diBankStandard';
export const ModuleBankStandardList = 'diBankStandardList';
export const ModuleDefaultAccount = 'diDefaultAccount';

export const ModuleAsset = 'diAsset';
export const ModuleAssetCategory = 'diAssetCategory';
export const ModuleAccountCategory = 'diAccountCategory';
export const ModuleCurrency = 'diCurrency';
export const ModuleReceipt = 'diReceipt';
export const ModuleBranch = 'diBranch';
export const ModuleArea = 'diArea';
export const ModuleDictionaryArea = 'dictionaryArea';
export const ModuleListCode = 'diListCode';
export const ModuleDataManagement = 'dataManagement';
export const ModuleDataManagementList = 'dataManagementList';
export const ModuleNotification = 'notification';

export const ModuleCACashReceipt = 'caCashReceipt';
export const ModuleCACashPayment = 'caCashPayment';
export const ModuleTicketBusiness = 'ticketBusiness';
export const ModuleFptPayment = 'fptPayment';
export const ModuleFptInwardStock = 'fptInwardStock';
export const ModuleFptOutwardStock = 'fptOutwardStock';
export const ModuleFptPayout = 'fptPayout';
export const ModuleFptDistributionMoney = 'fptDistributionMoney';
export const ModuleFptAdvancePayment = 'fptAdvancePayment';
export const ModuleFptAdvanceRequest = 'fptAdvanceRequest';

export const ModuleStaticReportPrint = 'staticReportPrint';

export const ModuleAccountTransferSlip = 'accountTransferSlip';

//  Lịch sử filter
export const ModuleFilterHistory = 'diFilterHistory';
export const ModuleOrderPopupStore = 'orderPopup';

/**
 * Danh sách module của chương trình
 */

// Quyết định
export const ModuleJusticeCase = 'diJusticeCase';
export const ModuleJusticeCaseType = 'diJusticeCaseType';
export const ModuleJusticeDecision = 'diJusticeDecision';
export const ModuleJusticeDecisionGroup = 'diJusticeDecisionGroup';
export const ModuleAccountingObject = 'diAccountingObject';

// Phân phối
export const ModuleAccountTransferSlipVoucher = 'voucherAccountTransferSlip';
export const ModuleVoucherList = 'voucherList';
export const ModuleJusticeReceipt = 'justiceReceipt';
export const ModuleDistributionSellingAsset = 'distributionSellingAsset';

//#region Phân hệ tài sản
export const ModuleInwardStock = 'assetInwardStock';
export const ModuleOutwardStock = 'assetOutwardStock';
export const ModuleAssetTransfer = 'assetTransfer';
export const ModuleInventory = 'inventory';
//#endregion

//#region Phân hệ tiền gửi ngân hàng
export const ModuleCheque = 'depositCheque';
export const ModuleDeposit = 'depositDeposit';
export const ModuleDepositInwardStock = 'depositInwardStock';
export const ModuleJetpayBankHub = 'depositJetpayBankHub';
//#endregion

// Các màn hình phân hệ sổ cái
export const ModuleGeneralJournalEntry = 'generalJournalEntry';
export const ModuleAssetEvaluation = 'assetEvaluation';
export const ModuleAssetEvaluationDetail = 'assetEvaluationDetail';
export const ModuleSubmitReportDetail = 'submitReportDetail';

// Màn hình phân hệ tổng hợp toàn ngành
export const ModuleReceiptSubOrgReport = 'receiptSubOrgReport';
// Các màn hình phân hệ tổng hợp toàn ngành 
export const ModuleAllSummary = 'allSummary';

// Nhật ký truy cập
export const ModuleAccessHistory = 'diAccessHistory';
// Hệ thống
export const ModuleInfoData = 'infoData';
export const ModuleChangeObject = 'changeObject';
export const ModuleTransferExecutor = 'transferExecutor';
export const ModuleCheckValidAmount = 'checkValidAmount';
export const ModuleCheckValidVoucher = 'checkValidVoucher';
export const ModuleUserManagement = 'userManagement';
//#endregion
export const ModuleProgress = 'progress';

export const ModuleInitialBalance = 'initialBalance';

export const ModuleHideShowColumn = 'hideShowColumn';
export const ModuleTaskLog = 'taskLog';

export const ModuleEsign = 'esign';

// Kho bạc điện tử
export const ModuleDVCFile = 'dvcFile';

export const AppModules = [
  ModuleBankInfo,
  ModuleBankStandard,
  ModuleBranch,
  ModuleArea,
  ModuleDictionaryArea,
  ModuleOrderPopupStore,
  ModuleDataManagement,
  ModuleDataManagementList,
  ModuleJusticeCase,
  ModuleJusticeCaseType,
  ModuleJusticeDecision,
  ModuleJusticeDecisionGroup,
  ModuleAccountingObject,
  ModuleEmployee,
  ModuleContext,
  ModuleEmployee,
  ModuleDbOption,
  ModuleAccount,
  ModuleStock,
  ModuleDiCacheConfig,
  ModuleAccountTransfer,
  ModuleDefaultAccount,
  ModuleAsset,
  ModuleAssetCategory,
  ModuleAccountCategory,
  ModuleCurrency,
  ModuleReceipt,
  ModuleListCode,
  ModuleNotification,
  ModuleAccountTransferSlip,
  ModuleFilterHistory,
  //#region Phân hệ tài sản
  ModuleInwardStock,
  ModuleOutwardStock,
  ModuleAssetTransfer,
  //#endregion,
  ModuleJusticeReceipt,

  //#region Phân hệ tiền gửi ngân hàng
  ModuleCheque,
  ModuleDeposit,
  ModuleJetpayBankHub,
  //#endregion
  ModuleGeneralJournalEntry,
  ModuleAssetEvaluation,
  //#region phân hệ tổng hợp toàn ngành
  ModuleReceiptSubOrgReport,
  ModuleAllSummary,
  //#endregion
  
  //#region Hệ thống
  ModuleAccessHistory,
  ModuleInfoData,
  ModuleChangeObject,
  ModuleTransferExecutor,
  ModuleCheckValidAmount,
  ModuleCheckValidVoucher,
  ModuleUserManagement,
  //#endregion
  ModuleProgress,

  ModuleInitialBalance,
  ModuleHideShowColumn,
  ModuleTaskLog,
  ModuleEsign
];
